'use strict';

const BaseStore = require('fluxible/addons/BaseStore');
const SV        = require('server-vars');


class CartCopyStore extends BaseStore {

    constructor(dispatcher) {
        super(dispatcher);

        this._cartCopy = SV.get('cartData.cartCopy') || {};
        this._cartText = SV.get('settings.globalCartCopy.cartBottomText');
    }

    getCartText() {
        return this._cartText;
    }

    getSoldItemText() {
        return this._cartCopy.soldItem || '';
    }
}

CartCopyStore.storeName = 'CartCopyStore';

module.exports = CartCopyStore;



// WEBPACK FOOTER //
// ./assets/js/global/stores/CartCopyStore.es.js